import "./styles.less";

import React, { ReactElement } from "react";

import { FormButton } from "./FormButton/web";
//import { PhoneButton } from "./PhoneButton/web";
import { PropComponentMode } from "../../PropertyInterfaces";
//import { WhatsappButton } from "./WhatsappButton/web";
import { usePhoneButton } from "./PhoneButton/hook";
import { useWhatsppButton } from "./WhatsappButton/hook";
import { ModalState } from "../TextForm/type";

import dynamic from "next/dynamic"
//@ts-ignore
const WhatsappButton = dynamic(() => import("./WhatsappButton/web").then(mod => mod.WhatsappButton), { ssr: false });
const PhoneButton = dynamic(() => import("./PhoneButton/web").then(mod => mod.PhoneButton), { ssr: false });

export const LeadButtons = ({
	id,
	children = null,
	mode,
	disabled = false,
	isInListing = false,
	sizeCard,
	queryRouter,
	listing,
	onlyConsult = false,
	onPhoneClick,
	onWpClick,
	forceState = ModalState.DEFAULT,
	idealFilters,
	isProject
}: {
	id: any;
	children?: ReactElement;
	mode: PropComponentMode;
	disabled?: boolean;
	isInListing?: boolean;
	sizeCard?: string;
	queryRouter?: string;
	listing?: any;
	onlyConsult?: boolean;
	onPhoneClick?: () => void;
	onWpClick?: () => void;
	forceState?: ModalState;
	idealFilters?: any,
	isProject?: boolean
}) => {
	const { hasWhatsapp } = useWhatsppButton(id);
	const { masked_phone: hasPhone } = usePhoneButton({
		property_id: id,
	});

	return (
		<div
			className="property-lead-button"
			style={isInListing ? { textAlign: "right" } : null}>
			<div style={{ flex: 1 }} >
				{children ?? (
					<FormButton id={id} isInListing={isInListing} sizeCard={sizeCard} idealFilters={idealFilters ?? undefined} isProject={isProject ?? false} />
				)}
			</div>

			{hasPhone && !isInListing && !onlyConsult && (
				<div>
					<PhoneButton
						id={id}
						type={"callButton"}
						mode={mode}
						forceState={forceState}
						disabled={disabled}
						queryRouter={queryRouter}
						onPhoneClick={onPhoneClick}
					/>
				</div>
			)}

			{hasWhatsapp && !isInListing && !onlyConsult && (
				<div>
					<WhatsappButton
						mode={mode}
						id={id}
						disabled={disabled}
						forceState={forceState}
						onWpClick={onWpClick}
						queryRouter={queryRouter}
					/>
				</div>
			)}
		</div>
	);
};



